import { render } from "./jbedit.vue?vue&type=template&id=31fa9b4d&scoped=true"
import script from "./jbedit.vue?vue&type=script&lang=js"
export * from "./jbedit.vue?vue&type=script&lang=js"

import "./jbedit.vue?vue&type=style&index=0&id=31fa9b4d&lang=scss&scoped=true"
import "./jbedit.vue?vue&type=style&index=1&id=31fa9b4d&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31fa9b4d"]])

export default __exports__